// extracted by mini-css-extract-plugin
export default {"Header_Cnt":"COM001F1_Header_Cnt__CCnQN","portalLogo":"COM001F1_portalLogo__FGNx1","infoBox":"COM001F1_infoBox__CTLDb"};